
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Menu, MenuPermissionMapping, Permission } from '../models/menu-permission.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MenuPermissionService {
      private apiUrl = `${environment.apiUrl}/api/menu`;
      private permUrl = `${environment.apiUrl}/api/Permission`;

      constructor(private http: HttpClient) { }

      getMenus(): Observable<Menu[]> { return this.http.get<Menu[]>(this.apiUrl); }

      getParentMenus(moduleId: string): Observable<Menu[]> { 
            return this.http.get<Menu[]>(`${this.apiUrl}/parent/${moduleId}`);
      }

      getMenusByUser(): Observable<Menu[]> { return this.http.get<Menu[]>(`${this.apiUrl}/menubyuser`); }

      createMenu(menu: Menu): Observable<Menu> { return this.http.post<Menu>(this.apiUrl, menu); }

      updateMenu(menu: Menu): Observable<any> { return this.http.put(this.apiUrl, menu); }

      deleteMenu(id: string): Observable<any> { return this.http.delete(`${this.apiUrl}/${id}`); }

      // Ensure this matches the base URL
      getPermissions(): Observable<Permission[]> {
            return this.http.get<Permission[]>(this.permUrl);
      }

      getAssignedPermissions(menuId: string): Observable<string[]> {
            return this.http.get<string[]>(`${this.apiUrl}/${menuId}/permissions`);
      }

      saveMapping(mapping: MenuPermissionMapping): Observable<boolean> {
            return this.http.post<boolean>(`${this.apiUrl}/assign-permissions`, mapping);
      }
}